export const nextPouleName = c => {
  if (c.length === 0) {
    return "A";
  }
  if (c.charCodeAt(0) === 90) {
    return "A".repeat(c.length + 1);
  }
  return String.fromCharCode(c.charCodeAt(0) + 1).repeat(c.length);
};
